const PUBTYPE = {
  PATIENT_HANDOUTS: "patient-handouts",
  CHEMO_REGIMEN: "chemo-regimen",
  LEADERSHIP: "leadership",
};

const SLUG_TO_PUBTYPE_MAP = {
  "drug-monographs": "fadrug",
  "drug-monograph": "drug",
  "drug-pediatric": "drugpediatric",
  "drug-neonatal": "drugneonatal",
};

module.exports = { PUBTYPE, SLUG_TO_PUBTYPE_MAP };
